export const userPath = "/users/me";
export const cardsPath = "/cards";
export const formValidators = {}
export const settingValidation = {
  formSelector: ".popup__form",
  inputSelector: '.popup__info',
  submitButtonSelector: '.popup__save-button',
  inactiveButtonClass: 'popup__save-button_disabled',
  inputErrorClass: 'popup__input_type_error',
  errorClass: 'popup__input_error_visible'
}